import Stack from "../Utils/Stack.styled";
import NavBarContainer from "./Nav.styled";
import { useState } from "react";
import Search from "../Search";
import { useScroll } from "../../helper/useScroll";
import { motion } from "framer-motion";
import useNavigateParams from "../../helper/navigateHelper";
import Button from "../Button";
import CONSTANT from "../../constants/constant";
import theme from "../../styles/Theme.styled";

const NavBar = ({ hideSearch, onClick }) => {
  const navigate = useNavigateParams();
  const [hasShadow, setHasShadow] = useState(0);
  useScroll((isScroll) => setHasShadow(isScroll ? 1 : 0));
  const getCurrentSearchKey = (key) => {
    navigate("/results", { q: key });
  };

  const onClickPlaylist = () => {
    navigate("/results/playlist");
    onClick(true);
  };
  return (
    <NavBarContainer
      as={motion.div}
      key="nav"
      initial={{ opacity: 0, y: "-80px" }}
      animate={{ opacity: 1, y: "0" }}
      transition={{
        duration: 1.5,
      }}
      shadow={hasShadow || 0}
    >
      <Stack
        justifyContent="space-between"
        width="100%"
        alignItems="center"
        paddingLeft="40px"
        paddingRight="40px"
      >
        <Search
          as={motion.div}
          layoutId="search"
          key="mainSearch"
          variant={CONSTANT.VARIANT.SMALL}
          onSearch={getCurrentSearchKey}
          hideSearch={hideSearch}
        />
        <Stack gap="8" justifyContent="end" alignItems="center" width="100%">
          <Button
            type={CONSTANT.ICON.PLAYLIST}
            background="transparent"
            hoverColor={theme.colors.primary}
            label="Your Playlist"
            iconSize="24px"
            fontSize="16px"
            padding="10px"
            onClick={() => onClickPlaylist()}
          />
        </Stack>
      </Stack>
    </NavBarContainer>
  );
};

export default NavBar;
